@if (data && data.processInstance) {
    <div class="px-2">
        <div class="row mb-3">
            <div class="col">
                <h2>
                    <em class="fas fa-eye pe-2"></em>
                    {{ 'Prozess Status für Rechnung \{\{number\}\} ' | translate: { number: data.invoiceNumber } }}
                </h2>
            </div>
            <div class="col-auto">
                <button mat-icon-button color="warn" (click)="close()">
                    <em class="fas fa-times fa-1_5x"></em>
                </button>
            </div>
        </div>
        @if (xml(); as xml) {
            <div class="row mx-auto">
                <div class="col">
                    <div class="bpmn-viewer-container">
                        <iim-bpmn-viewer
                            [config]="config"
                            [bpmnXml]="xml"
                            [highlights]="highlights()"
                        ></iim-bpmn-viewer>
                    </div>
                </div>
            </div>
        }
    </div>
}
@if (!xml()) {
    <div class="px-2 mb-4">
        <div class="row justify-content-center align-items-center h-100">
            <div class="col-auto">
                <iim-spinner size="medium" color="secondary"></iim-spinner>
            </div>
        </div>
    </div>
}
